
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { Patient } from "../../../domain/patient";

@Component({
})
export default class SpecifiedDocumentHandleableMixin extends Mixins() {
  @Prop()
  patientNo: string;

  @Prop()
  documentId: number;

  data(): any {
    return {
      patient: null as Patient,
    };
  }
  patient: Patient;

  created() {
    // 患者Noが指定されてない場合はエラーとする.
    if (!this.patientNo || this.patientNo === "") {
      this.$fatal(
        "患者番号未指定",
        "患者番号(patientNo)が指定されていません。"
      );
    }
    // 文書IDが指定されてない場合はエラーとする.
    if (!this.documentId) {
      this.$fatal(
        "文書ID未指定",
        "文書ID(documentId)が指定されていません。"
      );
    }
    const repository = DomainRegistry.patient.getPatientRepository();
    repository.getEntity(this.patientNo)
      .then(p => this.patient = p)
      .catch(e => {
        this.$fatal(
          "患者情報取得失敗",
          "指定された患者番号(patientNo)に該当する患者の情報を取得できませんでした。",
          e
        );
      });
  }
}
